import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { ExternalLinkTooltip } from "components/Tooltips/ExternalLinkTooltip";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    tooltipIcon: {
      width: "20px !important",
      height: "20px !important",
    },
    externalLink: {
      marginTop: theme.spacing(4),
    },
  }),
);

export function RedemptionCodeCampaignTooltip() {
  const { message } = useMessage();

  return (
    <ExternalLinkTooltip
      externalLink="https://help.openloyalty.io/main-features/campaigns#redemption-code-campaign"
      name="redemptionCode"
      text={message({ id: "redemptionCodeInfo" })}
    />
  );
}
